module.exports = __webpack_public_path__ + "static/media/stack_table_view_light.82f66cd3.svg";